var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotMobileUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.08 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#dc3545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Driver Not Using Mobile App") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.91,0h-14a2,2,0,0,0-2,2V5a.94.94,0,0,0,1,1,.94.94,0,0,0,1-1V4h14V24h-14V23a.94.94,0,0,0-1-1,.94.94,0,0,0-1,1v3a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2V2A2,2,0,0,0,20.91,0Z",
    transform: "translate(-0.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.12,13.61l4.14-4.14a.69.69,0,0,0-1-1L6.14,12.64,2,8.5a.69.69,0,1,0-1,1l4.14,4.14L1,17.74a.69.69,0,1,0,1,1l4.14-4.14,4.14,4.14a.69.69,0,1,0,1-1Z",
    transform: "translate(-0.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotMobileUser);
export default __webpack_public_path__ + "static/media/notMobileUser.27cfa9eefd95705893e18aa967e55562.svg";
export { ForwardRef as ReactComponent };